// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__tV+Lh","search":"Search_search__duKmH","searchButton":"Search_searchButton__-sHkf"};